import React from 'react';
import {Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContenedorBoton, ContainerCol } from '../componentes_generales/componentes_formulario/contenedores/';
import { LabelForm } from '../componentes_generales/componentes_formulario/labels/';
import AgGridRender from '../componentes_generales/grid/ag_grid_render';
import ReactSelect from '../componentes_generales/componentes_formulario/selects/react-select';
import ReactSelectAsync from '../componentes_generales/componentes_formulario/selects/react-select-async';
import { cargarCatalogosGenericoAsync } from '../../funciones_globales/catalogos';
import PickerFecha from '../componentes_generales/componentes_formulario/datepicker/datepicker';
import { InputText } from '../componentes_generales/componentes_formulario/inputs/inputtext';
import moment from 'moment';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import global_axios from '../../funciones_globales/interaccionapi';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';
import { cargar_ChequesporCliente } from '../../actions/clientes/act_cli02';
import { cambiar_VisualizacionLoading } from '../../actions/generales/act_gen01';
import { validarCampoString, validarPermisoAcceso, validarFechaTransaccionSeleccionada, validarFechaMomentEnFormatoString, esNumero} from '../../funciones_globales/utils';
import styled from 'styled-components';
import Tooltip from 'rc-tooltip';
import 'rc-tooltip/assets/bootstrap.css';
import { getItemDatosSesion, getFechaProcesoPorModulo } from '../../funciones_globales/manejosesion';
import { formatearFechaMoment_a_String } from '../../funciones_globales/format';
import { cargar_CuentasBancarias } from '../../actions/bancos/act_banc01';

const LabelCheques = styled.label`
  display: inline-block;
  font-size: 12px;
  padding-top: 15px;
  font-style: italic;
`;

const LabelChequeSel = styled.label`
  display: inline-block;
  font-size: 11px;
  font-weight: 500;
`;

class FormCli07 extends React.Component{
  
  constructor(props) {
    super(props);
    this.state = {
      operacion: 'G',
      fechaProtesto: null,
      cliente_sel: null,
      chequesDepositados: [],
      valorProtesto: '',
      cheque_sel: null,
      valorDebito: '',
      observacion: '',
      cuentaBancoDep: null,
      cuentasBancarias: [],
      cuenta_sel: null,

      columnsDefGridCheques: [
        { header: "",
          width: 30,
          checkboxSelection: true,
          suppressSorting: true,
          suppressMenu: true,
          suppressFilter: true,
          pinned: true
        },
        { header: "No.",
          field: "Secuencia",
          width: 30,
          type: "string",
          suppressFilter: true          
        },
        {
          header: "Banco",
          field: "Banco",
          width: 130,
          type: "string"
        },
        { header: "Cuenta",
          field: "Cuenta",
          width: 90,
          type: "string"
        },
        { header: "Cheque",
          field: "Cheque",
          width: 70,
          type: "string"
        },
        { header: "Valor",
          field: "Valor",
          width: 80,
          type: "num_decimal",
          filter: "number"
        },
        { header: "Estado",
          field: "Estado",
          width: 60,
          type: "string",
          suppressFilter: true,
          suppressSorting: true
        },
        { header: "Factura",
          field: "Factura",
          width: 95,
          type: "string",
          suppressSorting: true
        },
        { header: "Fecha",
          field: "FechaCheque",
          width: 80,
          type: "string"          
        },
        { header: "F. Venc.",
          field: "FecVencimiento",
          width: 80,
          type: "string"          
        },
        { header: "Saldo",
          field: "Saldo",
          width: 80,
          type: "num_decimal",
          filter: "number"
        },
        { header: "Caja",
          field: "Caja",
          width: 50,
          type: "string",
          suppressFilter: true,
          suppressSorting: true
        },
        { header: "Mov. Caja",
          field: "Movimiento",
          width: 90,
          type: "string"
        },
        { header: "Mov. Banco",
          field: "MovBanco",
          width: 90,
          type: "string"
        }
      ]
    };
    
    this.gridChequesOptions = {
      enableColResize: true,
      enableCellChangeFlash: true,
      enableFilter: true,
      suppressRowClickSelection: true,
      enableSorting: true,
      onSelectionChanged:  (event)=>{ this.onSelectionChequeChanged() }
    };
    
    this.onGridChequesReady = this.onGridDetChequesReady.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.limpiar = this.limpiar.bind(this);
    this.getOptions_Clientes = this.getOptions_Clientes.bind(this);
    this.onSelectionChequeChanged = this.onSelectionChequeChanged.bind(this);
    this.cargarChequesPorCliente = this.cargarChequesPorCliente.bind(this);
    this.procesarProtestoCheque = this.procesarProtestoCheque.bind(this);
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  getOptions_Clientes(input, callback){
    if (input.toString().length >= 3 ){
      let query = "?tipo=catalogo&cadena_busq=" + input;
      cargarCatalogosGenericoAsync('/clientes', query, callback)
    }
  }

  onGridDetChequesReady(params) {
    this.apiGridCheques = params.api;
    this.columnApiGridCheques = params.columnApi;
  }
  
  componentDidMount(){    
    let fechaProceso = getFechaProcesoPorModulo('01');  
    this.props.generar_LogAuditoriaIngresoForm('0107');
    this.props.cargar_CuentasBancarias('CC')
    .then(()=>{
      let catalogoCtasBancarias = [];
      this.props.cuentasBancarias.forEach(item => {        
        catalogoCtasBancarias.push({value: item.Cuenta, label: `${item.Nombre.toString().trim().toUpperCase()} (${item.Numero.toString().trim()})`});        
      });

      this.setState({ cuentasBancarias: catalogoCtasBancarias, 
                      fechaProtesto: moment(fechaProceso, 'DD/MM/YYYY') });
    });    
  }
  
  componentWillUnmount(){
    this.props.generar_LogAuditoriaSalidaForm('0107');
  }

  onSelectionChequeChanged(){
    let chequesSeleccionados = this.apiGridCheques.getSelectedRows();
        
    if (chequesSeleccionados.length===1){      
      
      let movBancoId = chequesSeleccionados[0].MovBanco;
      if(validarCampoString(movBancoId, 6)){
        global_axios({
          method: 'GET',
          url: `/movimientosbanco/${movBancoId}`
        })
        .then((response)=>{
          this.setState({cheque_sel:
            { Banco: chequesSeleccionados[0].Banco,
              Cuenta: chequesSeleccionados[0].Cuenta,
              Cheque: chequesSeleccionados[0].Cheque,
              Valor: parseFloat(chequesSeleccionados[0].Valor || 0).toFixed(2)
            },
            cuentaBancoDep: response.data.Cuenta
          });
        })
        .catch((error)=> {
          alert(error.response?error.response.data.msg:error.message);
        });
      }else{
        this.setState({cheque_sel:
          { Banco: chequesSeleccionados[0].Banco,
            Cuenta: chequesSeleccionados[0].Cuenta,
            Cheque: chequesSeleccionados[0].Cheque,
            Valor: parseFloat(chequesSeleccionados[0].Valor || 0).toFixed(2)
          },
          cuentaBancoDep: null
        });
      }
    }else{
      this.setState({cheque_sel: null, cuentaBancoDep: null});
    }
  }

  cargarChequesPorCliente(){
    let clienteId = this.state.cliente_sel.value;
    if (!validarCampoString(clienteId, 7)){
      alert('Debe seleccionar el cliente del cual desea consultar los cheques.');
      return;
    }
    else{
      this.props.cargar_ChequesporCliente(clienteId, 'D')
      .then(()=>{
        try {
          if (this.props.cheques.length>0){
            let chequesDepositados = [];
            this.props.cheques.forEach((cheque, i) => {
              chequesDepositados.push({
                Secuencia: (i+1),
                Banco: cheque.banco.Codigo + ' - ' + cheque.banco.Descripcion,
                Cuenta: cheque.Cuenta,
                Cheque: cheque.Cheque,
                Valor: cheque.Valor,
                Estado: cheque.Status,
                Factura: cheque.Factura,
                FechaCheque: cheque.FechaCheque,
                FecVencimiento: cheque.Vencimiento,
                Saldo: cheque.Saldo,
                Caja: cheque.Caja,
                Movimiento: cheque.Movimiento,
                MovBanco: cheque.MovBanco
              });
            });
            this.setState({chequesDepositados});
          }else{
            alert('No existen cheques depositados para el cliente seleccionado.');
          }
        } catch (error) {
          alert(`Ha ocurrido un error al cargar los cheques. Error: ${error}`);
        }
      });
    }
  }

  limpiar(){
    let fechaProceso = getFechaProcesoPorModulo('01');
    this.setState({
      fechaProtesto: moment(fechaProceso, 'DD/MM/YYYY'),
      cliente_sel: null,
      chequesDepositados: [],
      valorProtesto: '',
      cheque_sel: null,
      valorDebito: '',
      observacion: '',
      cuentaBancoDep: null,
      cuenta_sel: null
    });
  }

  procesarProtestoCheque(){
    try{
      let fechaProceso = getFechaProcesoPorModulo('01');

      let validPermiso = validarPermisoAcceso(this.state.operacion, this.props.permiso);
      if (!validPermiso.esValido){
        alert(validPermiso.msg);
        return;
      }

      if(this.state.cliente_sel === null){
        alert('No ha especificado un cliente.');
        return;
      }

      if ((this.state.chequesDepositados.length===0) || (this.state.cheque_sel===null)){
        alert('No ha seleccionado el cheque que va a protestar.');
        return;
      }

      if (this.state.cuentaBancoDep === null){
        alert('No ha especificado la cuenta en la cual se depositó el cheque.');
        return;
      }

      if (!esNumero(this.state.cheque_sel.Valor)){
        alert('El valor del cheque es incorrecto.');
        return;
      }

      if (!esNumero(this.state.valorProtesto)){        
        alert('El valor de multa por protesto es incorrecto.');
        return;
      }else{
        if(parseFloat(this.state.valorProtesto)<=0){
          alert('El valor de multa por protesto es incorrecto.');
          return;
        }
      }
      
      if (!esNumero(this.state.valorDebito)){
        alert('El valor total de la N/D por protesto es incorrecto.');
        return;
      }else{
        if(parseFloat(this.state.valorProtesto)<=0){
          alert('El valor de multa por protesto es incorrecto.');
          return;
        }
      }

      let totalNotaDebProt = parseFloat(this.state.cheque_sel.Valor)+parseFloat(this.state.valorProtesto);
      
      if (parseFloat(this.state.valorDebito).toFixed(2) !== parseFloat(totalNotaDebProt).toFixed(2)){
        alert('El valor total de la N/D por protesto no puede ser diferente a la suma entre el valor del cheque y el valor de la multa.');
        return;
      }
      
      let fechaProtesto = formatearFechaMoment_a_String(this.state.fechaProtesto);
      if (!validarFechaMomentEnFormatoString(fechaProtesto)){
        alert('La fecha de protesto es inválida.');
        return;
      }

      if(this.state.observacion.trim().length === 0){
        alert('No ha especificado una observación.');
        return;
      }

      if (this.props.permiteCambioFProceso==='S'){
        let validFProceso = validarFechaTransaccionSeleccionada(this.state.fechaProtesto, moment(fechaProceso, 'DD/MM/YYYY'), this.props.diasPermiteCambioFProceso);
        
        if(!validFProceso.esValida){
            alert(validFProceso.msg);
            return;
        }
      }
          
      let protestoCheque = {
        fechaProtesto: formatearFechaMoment_a_String(this.state.fechaProtesto),
        valorCheque: parseFloat(this.state.cheque_sel.Valor).toFixed(2),
        valorProtesto: parseFloat(this.state.valorProtesto).toFixed(2),
        valorChequeProtesto: parseFloat(this.state.valorDebito).toFixed(2),
        observacion: this.state.observacion,
        cuentaDepositada: this.state.cuentaBancoDep,
        usuario: getItemDatosSesion('usuario').toString(),
        moneda:  JSON.parse(getItemDatosSesion('moneda')).Moneda,
        dolar: JSON.parse(getItemDatosSesion('moneda')).Cotizacion,
        idRegAudit: this.props.idRegAudit
      }
          
      this.props.cambiar_VisualizacionLoading(true);

      let url = `/chequescliente/${this.state.cliente_sel.value}/${this.state.cheque_sel.Banco.trim().substr(0,2)}/${this.state.cheque_sel.Cuenta}`;
      url += `/${this.state.cheque_sel.Cheque}/protestos`;

      global_axios({
        method: 'POST',
        url,
        data: protestoCheque
      })
      .then((response)=>{
        this.props.cambiar_VisualizacionLoading(false);
        alert(`Se registró correctamente el protesto del cheque seleccionado. Nota de Débito generada: ${response.data.notaDebitoGenerada}`);
        this.limpiar();
      })
      .catch(error => {
        this.props.cambiar_VisualizacionLoading(false);
        alert(error.response?error.response.data.msg:error.message);
      });
    }catch(error){
      alert(`Ocurrió un error al procesar el registro de protesto del cheque seleccionado. Error: ${error}`);
    }
  }

  render(){
    return(
      <ContenedorForm porc_ancho={80}>
        <HeaderForm>
          <TituloForm>Protesto de Cheques</TituloForm>
        </HeaderForm>
        <CuerpoForm>
          <Row>
            <ContainerCol className='col-sm-4'>
              <LabelForm>Cliente:</LabelForm>
              <ReactSelectAsync value={this.state.cliente_sel} func_loadOptions={this.getOptions_Clientes}
                func_onChange={(value)=>{if(Array.isArray(value)){value=null};  this.limpiar(); this.setState({cliente_sel: value})} }/>
            </ContainerCol>
            <ContainerCol className='col-sm-1'>
              <ContenedorBoton margen_arriba={20}>
                <Tooltip placement='right' overlay='Buscar cheques depositados del cliente seleccionado.'>
                  <button type='button' className='btn btn-success btn-sm' onClick={this.cargarChequesPorCliente}><i className='fa fa-search'></i></button>
                </Tooltip>
              </ContenedorBoton>
            </ContainerCol>
          </Row>
          <Row>
            <ContainerCol className='col-sm-12'><LabelCheques>Cheques depositados:</LabelCheques></ContainerCol>
          </Row>
          <Row>
            <ContainerCol className='col-sm-12'>
            <AgGridRender altura='275px' data={this.state.chequesDepositados} columnas={this.state.columnsDefGridCheques}
              gridOptions={this.gridChequesOptions} onGridReady={this.onGridChequesReady}/>
            </ContainerCol>
          </Row>
          <Row>
            <ContainerCol className='col-sm-3'>
              <LabelForm>Cheque seleccionado:</LabelForm>
              <LabelChequeSel>
                {(this.state.cheque_sel!=null?`No.: ${this.state.cheque_sel.Cheque} | Cta.: ${this.state.cheque_sel.Cuenta} | Bco.: ${this.state.cheque_sel.Banco}`:'')}
              </LabelChequeSel>
            </ContainerCol>
            <ContainerCol className='col-sm-3'>
              <LabelForm>Cheque depositado en:</LabelForm>
              <ReactSelect options={ this.state.cuentasBancarias } value={this.state.cuentaBancoDep} func_onChange={(value)=>{this.setState({cuentaBancoDep: value===null?null:value.value})}}/>
            </ContainerCol>
            <ContainerCol className='col-sm-2'>
              <LabelForm>Valor total N/D:</LabelForm>
              <InputText autoComplete='off' name='valorDebito' value={this.state.valorDebito} type='number' className='form-control input-sm' placeholder='Valor total N/D:'
                onChange={this.handleInputChange}/>
            </ContainerCol>            
            <ContainerCol className='col-sm-2'>
              <LabelForm>Valor del Cheque:</LabelForm>
              <InputText autoComplete='off' name='valorCheque' value={(this.state.cheque_sel!=null?this.state.cheque_sel.Valor:0)} type='number' className='form-control input-sm' placeholder='Valor Cheque'
                readOnly={true} onChange={this.handleInputChange}/>
            </ContainerCol>
            <ContainerCol className='col-sm-2'>
              <LabelForm>Valor Multa Protesto:</LabelForm>
              <InputText autoComplete='off' name='valorProtesto' value={this.state.valorProtesto} type='number' className='form-control input-sm' placeholder='Valor Protesto'
                onChange={this.handleInputChange}/>
            </ContainerCol>           
          </Row>
          <Row>
            <ContainerCol className='col-sm-2'>
              <LabelForm>Fecha de Protesto:</LabelForm>
              <PickerFecha fechaSeleccionada={this.state.fechaProtesto} disabled={!(this.props.permiteCambioFProceso==='S')}
                func_onChange={(fecha)=>{this.setState({fechaProtesto: fecha})}}/>
            </ContainerCol>
            <ContainerCol className='col-sm-8'>
              <LabelForm>Observación:</LabelForm>
              <InputText autoComplete='off' name='observacion' value={this.state.observacion} type='text' className='form-control input-sm' placeholder='Observación'
                onChange={this.handleInputChange}/>
            </ContainerCol>
          </Row>
          <Row>
            <ContainerCol className='col-sm-12' margen_arriba={15}>
              <div className='btn-group pull-right'>
                <button type='button' className='btn btn-primary btn-sm' onClick={this.procesarProtestoCheque}><i className='fa fa-floppy-o fa-lg'/> Registrar Protesto</button>
                <button type='button' className='btn btn-sm' onClick={this.limpiar}><i className='fa fa-trash-o fa-lg'/> Limpiar</button>
              </div>
            </ContainerCol>
          </Row>
        </CuerpoForm>
      </ContenedorForm>
    );
  }  
}

const mapStateToProps = state =>{
  return {  permiso: state.sesion.valoresSesionForm.Permiso,
            idRegAudit: state.sesion.valoresSesionForm.IdRegAudit,
            cheques: state.clientes.cheques,
            permiteCambioFProceso: state.sesion.valoresSesionForm.CambioFechaProceso,
            diasPermiteCambioFProceso: state.sesion.valoresSesionForm.CantidadDias,
            cuentasBancarias: state.bancos.cuentasBancarias,
  };
};

const mapDispatchToProps = ((dispatch) => {  
  return bindActionCreators({ generar_LogAuditoriaIngresoForm,
                              generar_LogAuditoriaSalidaForm,
                              cambiar_VisualizacionLoading,
                              cargar_ChequesporCliente,
                              cargar_CuentasBancarias
                            }, dispatch)
});

export default connect (mapStateToProps, mapDispatchToProps)(FormCli07);